import { useEffect, useMemo } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { CONSTANTS } from '../constants/constants';
import ApplicationSettingService from '../services/applicationSettingService';
import { IdentityProvider } from '../enums/identityProvider';

const ConsentPopup = () => {
  const auth = useAuth();

  // Parse params once
  const params = useMemo(() => {
    return new URLSearchParams(window.location.hash.replace('#/auth-start', ''));
  }, []);

  // Check if this is a logout flow
  const isLogout = useMemo(() => {
    const identityServerParam = params.get('identityServerUrl');
    const authorityUrl: string = identityServerParam ? decodeURIComponent(identityServerParam) : '';
    return authorityUrl.toLowerCase().includes('/auth/logout');
  }, [params]);

  useEffect(() => {
      const authId = params.get('authId');
      const method = params.get('oauthRedirectMethod');
      const redirectUrl = encodeURIComponent(params.get('hostRedirectUrl')!);
      const identityServerParam = params.get('identityServerUrl');
      const authorityUrl: string = identityServerParam ? decodeURIComponent(identityServerParam) : '';
      const identityProvider = params.get('identityProvider');
      const loginHint: string = params.get('loginHint') ?? '';
      const appClientId: string = ApplicationSettingService.getAppSettingByKey(CONSTANTS.app_client_id);
      
      if (identityProvider === IdentityProvider.PI.toString()) {
          window.location.replace(`${authorityUrl}&redirectUri=${redirectUrl}`);
          return;
      }

      const state = `"authId":${authId}|"method":${method}`;
      const scope = "CarpeWebApi%20offline_access%20openid%20Roles%20profile";
      let url = `${authorityUrl}connect/authorize?client_id=${appClientId}&redirect_uri=${redirectUrl}&response_type=code&scope=${scope}&nonce=3cc8eca0aa59e70be58375f817ff976d202GM3xKh&state=${state}&code_challenge=51FaJvQFsiNdiFWIq2EMWUKeAqD47dqU_cHzJpfHl-Q&code_challenge_method=S256`;
      
      if (loginHint) {
          url += `&login_hint=${loginHint}`;
      }
      
      window.location.href = url;
  }, [params]);

  return (
      <div>
          <h1>{isLogout ? 'Logging out...' : 'Authenticating.'}</h1>
      </div>
  );
};

export default ConsentPopup;